import React, {PropsWithChildren, ReactNode} from "react";
import {useField} from "formik";
import FormFieldError from "./FormFieldError";

interface FormFieldPropsI {
    label: string,
    id?: string,
    name: string,
    labelButton?: ReactNode
}

const FormField: React.FC<PropsWithChildren<FormFieldPropsI>> = (props) => {

    const [_, meta] = useField(props.name);

    return (
        <div className="blj-store-locator-form__field">

            <div className="blj-store-locator-form__field-label">
                <label htmlFor={props.id}>
                    {props.label}
                </label>

                {props.labelButton && (
                    props.labelButton
                )}
            </div>

            {props.children}

            {meta.error && meta.touched && (
                <FormFieldError errorMessage={meta.error}/>
            )}

        </div>
    );
}

export default FormField;